/* assets/upsell-toggle.js */
(function registerSheetUpsell() {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Find all upsell checkboxes on the page/section
  function findCheckboxes(ctx) {
    return Array.from((ctx || document).querySelectorAll('[data-upsell-checkbox]'));
  }

  async function getCart() {
    const res = await fetch(ROOT + 'cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  async function addOne(variantId) {
    const body = { items: [{ id: Number(variantId), quantity: 1 }] };
    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  }

  async function setQtyByKey(idOrKey, qty) {
    const body = { id: idOrKey, quantity: qty };
    const res = await fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error('Change failed');
    return res.json();
  }

  function findLine(cart, variantId) {
    return cart.items.find(i => i.variant_id === Number(variantId));
  }

  // Attach behavior to a single checkbox element
  function wireCheckbox($cb) {
    if ($cb.__upsellWired) return; // avoid double-binding on section reloads
    $cb.__upsellWired = true;

    variantId = $cb.value || $cb.dataset.variantId;
    let inFlight = false;

    // Initialize checked state from cart
    (async () => {
      try {
        const cart = await getCart();
        $cb.checked = !!findLine(cart, variantId);
      } catch (e) { /* ignore init errors */ }
    })();

    $cb.addEventListener('change', async () => {
      console.log("Default JS checkbox code fires remote");
      variantId = $cb.value || $cb.dataset.variantId;

      if (inFlight) return;
      inFlight = true;
      $cb.disabled = true;

      try {
        const cart = await getCart();
        const line = findLine(cart, variantId);

        if ($cb.checked) {
          // Checked → increment by 1 (or add if not present)
          if (line) {
            await setQtyByKey(line.key, line.quantity + 1);
          } else {
            await addOne(variantId);
          }
        } else {
          // Unchecked → decrement by 1 (remove if reaches 0)
          if (line) {
            const newQty = Math.max(0, line.quantity - 1);
            await setQtyByKey(line.key, newQty);
          }
        }

        document.dispatchEvent(new CustomEvent('upsell:sheet:changed'));
      } catch (err) {
        // Revert UI if it failed
        $cb.checked = !$cb.checked;
        console.error(err);
        // (optional) toast or alert
      } finally {
        $cb.disabled = false;
        inFlight = false;
      }
    });
  }

  // Bootstrappers (supports Online Store 2.0 section reloads)
  function init(ctx) {
    findCheckboxes(ctx).forEach(wireCheckbox);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => init(e.target));
})();
